import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class uniqueExperiences {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)

    const swiper = new Swiper(
      this.strip.find('.swiper-unique-experiences')[0],
      {
        direction: 'horizontal',
        effect: 'slide',
        centeredSlides: false,
        breakpoints: {
          320: {
            slidesPerView: 1.05,
            spaceBetween: 8,
          },
          576: {
            slidesPerView: 1.5,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: 2.05,
            spaceBetween: 16,
          },
          992: {
            slidesPerView: 2.5,
            spaceBetween: 32,
          },
          1279: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
        },
        navigation: {
          nextEl: '.s-unique-experiences-next',
          prevEl: '.s-unique-experiences-prev',
        },
        pagination: {
          el: '.s-unique-experiences-pagination',
          type: 'bullets',
          clickable: true,
        },
      }
    )
  }
}

export default uniqueExperiences
